import Gallery from "../../../../src/components/Gallery";
import * as React from 'react';
export default {
  Gallery,
  React
};